/* ============================================================
   köbi Video-Autoplay-Toggle — Controller
   ------------------------------------------------------------
   Pausiert / startet ALLE autoplay-Videos der Seite und merkt
   sich die Wahl seitenübergreifend (localStorage 'koebi:motion').

   Zusammenspiel mit dem <head>-Inline-Script (layout/theme.liquid):
   - Das Head-Script setzt VOR dem ersten Paint den Anfangszustand
     (html.koebi-motion-paused) und friert autoplay-Videos schon
     während des Parsens ein (kein Aufblitzen).
   - Dieses Script übernimmt danach: Button-Klicks, Laufzeit-Wechsel,
     dynamisch nachgeladene Videos (Theme-Editor, Slider-Clones) und
     reagiert auf OS-seitige prefers-reduced-motion-Änderungen, solange
     der Nutzer noch keine explizite Wahl getroffen hat.

   Begriffe:
   - "freeze": autoplay entfernen, Video pausieren, ersten Frame zeigen
     (currentTime = 0). Originaler autoplay-Zustand wird in
     data-koebi-autoplay gemerkt, damit "play" ihn wiederherstellen kann.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'koebi:motion'; // 'play' | 'pause'
  var PAUSED_CLASS = 'koebi-motion-paused';
  var root = document.documentElement;

  function readStored() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStored(value) {
    try {
      window.localStorage.setItem(KEY, value);
    } catch (e) {
      /* localStorage nicht verfügbar (z.B. Private-Mode) → State gilt nur diese Seite */
    }
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Aktueller Soll-Zustand: explizite Wahl schlägt OS-Default.
  function isPaused() {
    var stored = readStored();
    if (stored === 'pause') return true;
    if (stored === 'play') return false;
    return prefersReducedMotion();
  }

  // Die Videos, die im Theme autoplayen (gleiche Menge wie der bestehende
  // Autoplay-Kickstarter in layout/theme.liquid steuert).
  var MANAGED = 'video[autoplay], video[data-koebi-autoplay], .koebi-hero__video,' +
    ' .multicolumn-card__video, .multirow-card__video, .koebi-product-video video';

  function managedVideos() {
    return document.querySelectorAll(MANAGED);
  }

  function freeze(video) {
    if (!video) return;
    // Originalen autoplay-Zustand einmalig merken.
    if (!video.hasAttribute('data-koebi-autoplay')) {
      video.setAttribute('data-koebi-autoplay', video.autoplay || video.hasAttribute('autoplay') ? '1' : '0');
    }
    // Flag, das der bestehende Kickstarter respektiert → kein Re-Start.
    video.dataset.koebiHeroUserPaused = 'true';
    video.autoplay = false;
    video.removeAttribute('autoplay');
    try {
      video.pause();
      // Ersten Frame zeigen statt mittendrin einzufrieren.
      if (video.currentTime > 0) video.currentTime = 0;
    } catch (e) {
      /* manche Videos sind noch nicht weit genug geladen — egal, autoplay ist weg */
    }
  }

  function play(video) {
    if (!video) return;
    // Pause-Flag lösen, damit Kickstarter + prepareAutoplayVideo wieder greifen.
    video.dataset.koebiHeroUserPaused = 'false';
    if (video.getAttribute('data-koebi-autoplay') === '1') {
      video.setAttribute('autoplay', '');
      video.autoplay = true;
    }
    // Autoplay ohne Nutzergeste verlangt muted — diese Videos waren es ohnehin.
    video.muted = true;
    // Bestehende Theme-Helper nutzen (setzt muted/playsinline + spielt robust ab,
    // inkl. Fallback auf erste Nutzergeste bei mobilem Autoplay-Block).
    if (typeof window.koebiPrepareAutoplayVideo === 'function') {
      window.koebiPrepareAutoplayVideo(video);
    } else {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function applyToAll(paused) {
    var videos = managedVideos();
    for (var i = 0; i < videos.length; i++) {
      if (paused) freeze(videos[i]);
      else play(videos[i]);
    }
  }

  function setState(paused, persist) {
    root.classList.toggle(PAUSED_CLASS, paused);
    if (persist) writeStored(paused ? 'pause' : 'play');
    applyToAll(paused);
    // Der sichtbare/zugängliche Button-Name (Label + Icon) wird rein per CSS
    // über html.koebi-motion-paused umgeschaltet — hier nichts weiter nötig.
  }

  function onToggleClick() {
    var nowPaused = !root.classList.contains(PAUSED_CLASS);
    setState(nowPaused, true);
  }

  function bindButtons() {
    var buttons = document.querySelectorAll('[data-koebi-motion-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-koebi-bound') === '1') continue;
      buttons[i].setAttribute('data-koebi-bound', '1');
      buttons[i].addEventListener('click', onToggleClick);
    }
  }

  // Dynamisch nachgeladene Videos (Theme-Editor-Reloads, Slideshow-Clones)
  // sofort an den aktuellen Zustand angleichen.
  function watchNewVideos() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      if (!root.classList.contains(PAUSED_CLASS)) return; // im Play-Modus nichts tun
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'VIDEO') {
            freeze(node);
          } else if (node.querySelectorAll) {
            var vids = node.querySelectorAll('video');
            for (var k = 0; k < vids.length; k++) freeze(vids[k]);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // OS-Einstellung live übernehmen, solange keine explizite Wahl getroffen wurde.
  function watchReducedMotion() {
    if (!window.matchMedia) return;
    var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    var handler = function () {
      if (readStored() !== null) return; // Nutzer hat selbst entschieden → nicht überschreiben
      setState(mql.matches, false);
    };
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(handler);
    }
  }

  function init() {
    bindButtons();
    // Mit dem (ggf. schon vom Head-Script gesetzten) Zustand synchronisieren,
    // ohne erneut zu persistieren.
    setState(isPaused(), false);
    watchNewVideos();
    watchReducedMotion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor: nach Section-Re-Render Buttons neu binden + Zustand anwenden.
  document.addEventListener('shopify:section:load', function () {
    bindButtons();
    setState(isPaused(), false);
  });
})();
